<template>
  <!-- begin #footer -->
  <div id="footer" class="footer" style="background-color: white">
    <img
      height="32px"
      width="32px"
      style="margin-right: 16px; margin-left: 16px"
      src="/assets/img/logo_base.png"
      alt=""
    />
    {{ copyrightLine }}
  </div>
  <!-- end #footer -->
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import packageJson from "../../../package.json";

function resolveProductKey() {
  const envProduct = (process.env.VUE_APP_PRODUCT || "")
    .replace(/['"]/g, "")
    .trim()
    .toLowerCase();

  if (envProduct === "mixora" || envProduct === "opt") {
    return envProduct;
  }

  return packageJson.name === "mixora" ? "mixora" : "opt";
}

export default {
  name: "Footer",
  data() {
    return {
      pageOptions: PageOptions,
      productKey: resolveProductKey(),
    };
  },
  computed: {
    brandLine() {
      return this.$t(`landing.products.${this.productKey}.brandLine`);
    },
    copyrightYear() {
      return new Date().getFullYear();
    },
    copyrightLine() {
      return `© ${this.brandLine} - ${this.$t(
        "messages.copyrightCompany"
      )}${this.$t("messages.allRightsReserved")}${this.copyrightYear}`;
    },
  },
};
</script>
